import Image from 'next/image'
import { Html } from '@captaincause/ui/Html'
import { tm } from '@captaincause/ui/tm'
import { Button } from 'components/Button'
import type { Project } from '@captaincause/types'
import type { CampaignAbout as CampaignAboutType } from '@captaincause/types/cc/about'

interface CampaignAboutProps {
  campaignAbout?: CampaignAboutType
  className?: string
  innerClassName?: string
  backgroundColor: string
  textColor: string
  projects: Project[]
}

export function CampaignAbout({
  campaignAbout = undefined,
  className = '',
  innerClassName = '',
  backgroundColor,
  textColor,
  projects,
}: CampaignAboutProps) {
  if (!campaignAbout) {
    return null
  }

  const imageKeys = ['image2', 'image', 'image3', 'image4', 'image5'] as const
  const images = imageKeys
    .flatMap(key => projects.map(project => project[key]))
    .filter(Boolean)

  return (
    <section
      id="organization-section"
      className={tm('px-6 py-16 lg:px-10 xl:px-20', className)}
      style={{ backgroundColor }}
    >
      <div
        className={tm(
          'mx-auto flex flex-col-reverse gap-x-10 md:flex-row lg:gap-x-24',
          innerClassName,
        )}
      >
        <div className="flex flex-col gap-y-6 md:flex-1 lg:flex-[2]">
          {campaignAbout.title ? (
            <h2
              className="text-center text-2xl font-semibold md:text-left"
              style={{ color: textColor }}
            >
              {campaignAbout.title}
            </h2>
          ) : null}
          {campaignAbout.content ? (
            <Html
              className="text-center opacity-80 md:text-left"
              style={{ color: textColor }}
            >
              {campaignAbout.content}
            </Html>
          ) : null}
          {campaignAbout.url ? (
            <Button
              variant="secondary"
              large
              className="text-md w-full md:w-fit"
              style={{
                color: textColor,
                borderColor: textColor,
              }}
              href={campaignAbout.url}
            >
              En savoir plus
            </Button>
          ) : null}
        </div>
        <div className="mb-6 grid min-h-[340px] w-full grid-cols-2 grid-rows-2 gap-2 overflow-hidden rounded-xl md:mb-0 md:max-h-[240px] md:flex-1 lg:max-h-[unset] lg:flex-[2]">
          {images[0] ? (
            <div className="relative col-start-1 col-end-2 row-start-1 row-end-3 h-full w-full">
              <Image src={images[0]} alt="" className="object-cover" fill />
            </div>
          ) : null}
          <div className="relative col-start-2 col-end-3 row-start-1 row-end-2 h-full w-full">
            {images[1] ? (
              <Image src={images[1]} alt="" className="object-cover" fill />
            ) : null}
          </div>
          <div className="relative col-start-2 col-end-3 row-start-2 row-end-3 h-full w-full">
            {images[2] ? (
              <Image src={images[2]} alt="" className="object-cover" fill />
            ) : null}
          </div>
        </div>
      </div>
    </section>
  )
}
